import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { AuthService } from 'src/app/core/services/AuthService/auth.service';

@Component({
  selector: 'app-account-settings',
  standalone: true,
  templateUrl: './account-settings.component.html',
  imports: [
    MatFormFieldModule,
    ReactiveFormsModule,
    MatCardModule,
    MatButtonModule,
    MatTabsModule,
    MatIconModule,
    MatInputModule,
    RouterModule
  ],
})
export class AccountSettingsComponent {
  accountForm!: FormGroup;
  imagePreview!: string | ArrayBuffer | null;

  constructor(
    private formBuilder: FormBuilder,
    private  authService: AuthService
  ) {}

  async ngOnInit() {
    const user = await this.authService.getUser();
    const profile = user ? await this.authService.getUserProfile(user.email) : null;
    
    this.accountForm = this.formBuilder.group({
      username: [profile?.username || '', Validators.required],
      firstName: [profile?.firstName || '', Validators.required],
      lastName: [profile?.lastName || '', Validators.required],
      organization: [profile?.organization || ''],
      location: [profile?.location || ''],
      email: [profile?.email || '', [Validators.required, Validators.email]],
      phone: [profile?.phone || ''],
      birthday: [profile?.birthday || ''],
    });
  }

  // Função para processar a imagem carregada
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files[0]) {
      const file = input.files[0];

      // Limite de tamanho de 5 MB
      if (file.size > 5 * 1024 * 1024) {
        alert('O arquivo deve ter no máximo 5 MB');
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result; // Salva a pré-visualização
      };
      reader.readAsDataURL(file); // Converte a imagem para Base64
    }
  }

  onSubmit() {
    if (this.accountForm.valid) {
      // Processa os dados, inclusive com a imagem carregada
      console.log(this.accountForm.value);
    }
  }
}